import _extends from '@babel/runtime/helpers/extends';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { Box } from '../Box/Box.js';
import { Icon } from '../Icon/Icon.js';
import { Tooltip } from '../Tooltip/Tooltip.js';
import { Typography } from '../Typography/Typography.js';
import { jacketVariantTokens } from './Jacket.mappers.js';

var _excluded = ["size", "title", "leadingIcon", "caption", "position", "timer", "variant", "captionIconLabel", "justifyContent"];
var Jacket = function Jacket(_ref) {
  var size = _ref.size,
    title = _ref.title,
    leadingIcon = _ref.leadingIcon,
    caption = _ref.caption,
    position = _ref.position,
    timer = _ref.timer,
    _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? 'primary.intense' : _ref$variant,
    captionIconLabel = _ref.captionIconLabel,
    justifyContent = _ref.justifyContent,
    rest = _objectWithoutProperties(_ref, _excluded);
  var jacketVariantToken = jacketVariantTokens[variant];
  var captionElement = caption && /*#__PURE__*/React.createElement(Typography, {
    variant: "caption-default",
    lineClamp: 1
  }, caption);
  var tooltip = caption && /*#__PURE__*/React.createElement(Tooltip, {
    title: caption,
    pointerPosition: "below"
  }, /*#__PURE__*/React.createElement(Icon, _extends({
    size: "12",
    color: "base.inverted",
    id: "fill.symbol.circle-info"
  }, captionIconLabel ? {
    label: captionIconLabel
  } : {})));
  var LeadingIcon = function LeadingIcon() {
    if (!leadingIcon) {
      return null;
    }
    var isStringType = typeof leadingIcon === 'string';
    var iconA11yProps = {
      id: isStringType ? leadingIcon : leadingIcon.id,
      label: isStringType ? undefined : leadingIcon.label
    };
    return /*#__PURE__*/React.createElement(Icon, _extends({
      size: size === 's' ? '12' : '20',
      me: "8",
      color: jacketVariantToken.textColor
    }, iconA11yProps));
  };
  return /*#__PURE__*/React.createElement(Box, _extends({
    width: "100%",
    height: size === 's' ? '22px' : '36px',
    borderRadius: position === 'above' ? ['16', '16', '0', '0'] : ['0', '0', '16', '16'],
    backgroundColor: jacketVariantToken.backgroundColor,
    textColor: jacketVariantToken.textColor,
    display: "flex",
    alignItems: "center",
    px: "16",
    py: size === 's' ? '4' : '8',
    justifyContent: justifyContent
  }, rest), /*#__PURE__*/React.createElement(LeadingIcon, null), /*#__PURE__*/React.createElement(Box, {
    display: "flex",
    alignItems: "center"
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: size === 's' ? 'caption-default-strong' : 'body-s-strong',
    lineClamp: 1
  }, title)), caption && /*#__PURE__*/React.createElement(Box, {
    ms: size === 's' ? '8' : '12',
    display: "flex",
    alignItems: "center"
  }, size === 'm' ? captionElement : tooltip), timer && /*#__PURE__*/React.createElement(Box, {
    display: "flex",
    ms: justifyContent ? undefined : 'auto',
    ps: "8",
    whiteSpace: "nowrap"
  }, timer));
};
Jacket.displayName = 'Jacket';
Jacket.defaultProps = {
  size: 'm',
  position: 'above'
};

export { Jacket };
//# sourceMappingURL=Jacket.js.map
